module.exports = __webpack_public_path__ + "static/media/Poppins-Light-latinext.6731e1ba.woff2";